import { useEffect, useMemo, useState } from 'react';
import { fetchFiData } from '../utils/fiDataApi';

const cache = new Map();

function cacheKey(tickers) {
    return [...tickers].sort().join(',');
}

export default function useFiData(tickers) {
    const normalized = useMemo(
        () => [...new Set((tickers || []).filter(Boolean).map((t) => String(t).toUpperCase()))].sort(),
        [tickers],
    );
    const [data, setData] = useState(() => cache.get(cacheKey(normalized)) || {});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!normalized.length) {
            setData({});
            return undefined;
        }
        const key = cacheKey(normalized);
        if (cache.has(key)) {
            setData(cache.get(key));
            return undefined;
        }
        let cancelled = false;
        setLoading(true);
        setError(null);
        fetchFiData(normalized)
            .then((result) => {
                if (cancelled) return;
                cache.set(key, result);
                setData(result);
            })
            .catch((err) => {
                if (cancelled) return;
                setError(err?.message || 'fi-data fetch failed');
                setData({});
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [normalized]);

    return { data, loading, error };
}
